/* eslint-disable no-console */
import { drupalComponent } from '@nech/src/helpers/drupal-component';

(function (Drupal, once, $) {
  drupalComponent('nechGallery', {
    selector: '.nech-gallery',
    shared: {},

    attach(context, options) {},
    detach(context, options) {},

    instance($el) {
      const uuid = generateUUID();

      initializeGalleryItems($el, uuid);

      bindFancybox($el, uuid);

      const $loadMoreButton = $el.find('.nech-gallery-load-more .nech-gallery-button-load-more a');
      $loadMoreButton.on('click', function (e) {
        e.preventDefault();
        handleLoadMore($el, $loadMoreButton, uuid);
      });
    }
  });

  function generateUUID() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  function initializeGalleryItems($el: JQuery<HTMLElement>, uuid: string | number) {
    $el.find('.gallery-item').each((idx, item) => {
      const $item = $(item);
      if (!$item.attr('data-fancybox')) {
        $item.attr('data-fancybox', uuid);
      }
    });
  }

  function handleLoadMore($el: JQuery<HTMLElement>, $loadMoreButton: JQuery<HTMLElement>, uuid: string | number) {
    const initialItemCount = $el.find('.nech-gallery-list-item').length;
  
    $(document).on('ajaxComplete.nechGallery', function ajaxCompleteHandler() {
      const $newItems = $el.find('.nech-gallery-list-item').slice(initialItemCount);
  
      $newItems.find('a.gallery-item').attr('data-fancybox', uuid);
  
      const newSlides = $newItems.find('a.gallery-item').map((index, link) => ({
        src: $(link).attr('href') || '',
        caption: $(link).attr('data-caption') || '',
      })).get();
  
      if (newSlides.length) {
        const fancyboxInstance = Fancybox.getInstance();
        if (fancyboxInstance) {
          fancyboxInstance.carousel.appendSlide(newSlides);
          fancyboxInstance.reload();
        }
      }
    });
  
    $loadMoreButton.on('click', function (e) {
      e.preventDefault();
      $loadMoreButton.trigger('click.ajax');
    });
  }
  

  function bindFancybox($el: JQuery<HTMLElement>, uuid: string | number) {
    Fancybox.bind("[data-fancybox='" + uuid + "']", {
      on: {
        "reveal": () => {
          const items = $el.find('.nech-gallery-list-item');
          const currentSlide = Fancybox.getSlide();

          if (currentSlide && currentSlide.index === items.length - 1) {
            const $loadMoreButton = $el.find('.nech-gallery-load-more .nech-gallery-button-load-more a');
            
            if ($loadMoreButton.length && !$loadMoreButton.data('loading')) {
              $loadMoreButton.data('loading', true);
              $loadMoreButton.trigger('click');

              $(document).one('ajaxComplete', () => {
                let newArray: { src: string; caption: string; }[] = [];

                $el.find('.nech-gallery-list-item:gt(' + currentSlide.index + ')').each((index, item) => {
                  const $link = $(item).find('a');
                  if (!$link.attr('data-fancybox')) {
                    $link.attr('data-fancybox', uuid);
                    newArray.push({
                      src: $link.attr('href') || '',
                      caption: $link.attr('data-caption') || '',
                    });
                  }
                });

                if (newArray.length) {
                  const fancyboxInstance = Fancybox.getInstance();
                  if (fancyboxInstance) {
                    fancyboxInstance.carousel.appendSlide(newArray);
                    fancyboxInstance.reload();
                  }
                }

                $loadMoreButton.data('loading', false);
              });
            }
          }
        },
      },
    });
  }

})(Drupal, once, jQuery);